<ng-template #filtersContent>
  <div class="modal-content">
    <!-- Dimensions max du meuble -->
    <div class="filter-section">
      <label class="filter-label">Quelles sont les dimensions max souhaitées du meuble (cm)</label>
      <div class="slider-container">
        <input
          type="range"
          class="width-slider"
          [(ngModel)]="filters.maxFurnitureWidth"
          [min]="minWidth"
          [max]="maxWidth"
          [style.background]="
            'linear-gradient(to right, #0078d4 0%, #0078d4 ' +
            sliderPercentage +
            '%, #e0e0e0 ' +
            sliderPercentage +
            '%, #e0e0e0 100%)'
          " />
        <input
          type="number"
          class="width-input"
          [(ngModel)]="filters.maxFurnitureWidth"
          [min]="minWidth"
          [max]="maxWidth" />
      </div>
    </div>

    <!-- Nombre de tiroirs -->
    <div class="filter-section">
      <label class="filter-label">Nombre de tiroir(s)</label>
      <div class="toggle-group">
        <button
          class="toggle-button"
          [class.active]="filters.drawerCount === DrawerCount.Simple"
          (click)="onDrawerCountSelect(DrawerCount.Simple)">
          Simple
        </button>
        <button
          class="toggle-button"
          [class.active]="filters.drawerCount === DrawerCount.Double"
          (click)="onDrawerCountSelect(DrawerCount.Double)">
          Double
        </button>
        <button class="toggle-button" [class.active]="filters.drawerCount === null" (click)="onDrawerCountSelect(null)">
          Sans préférence
        </button>
      </div>
    </div>

    <!-- Présence de niche -->
    <div class="filter-section">
      <label class="filter-label">Présence de niche</label>
      <div class="toggle-group">
        <button class="toggle-button" [class.active]="filters.withNiche === true" (click)="onWithNicheSelect(true)">
          Avec
        </button>
        <button class="toggle-button" [class.active]="filters.withNiche === false" (click)="onWithNicheSelect(false)">
          Sans
        </button>
        <button class="toggle-button" [class.active]="filters.withNiche === null" (click)="onWithNicheSelect(null)">
          Sans préférence
        </button>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn-primary" (click)="onApplyFilters()">Filtrer ma recherche</button>
    @if (displayMode === 'modal') {
      <button class="btn-secondary" (click)="onSkipFilters()">Continuer sans filtrer</button>
    }
  </div>
</ng-template>

@if (displayMode === 'inline') {
  <div class="filters-inline">
    <ng-container [ngTemplateOutlet]="filtersContent"></ng-container>
  </div>
}

@if (displayMode === 'modal' && isOpen) {
  <div class="modal-overlay" (click)="onClose()">
    <div class="modal-container" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2 class="modal-title">Filtres</h2>
        <button class="close-button" (click)="onClose()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>

      <ng-container [ngTemplateOutlet]="filtersContent"></ng-container>
    </div>
  </div>
}
